import TicketStack from 'components/dashboard/EntriesAndStats/TicketStack';
import { PromoCodeEntry } from 'components/enter/order-summary/PromoCodeEntry';
import EnterLayout from 'components/enter2026/EnterLayout';
import OrderSummaryCosts from 'components/enter2026/OrderSummaryCosts';
import OrderSummaryRows from 'components/enter2026/OrderSummaryRows';
import MainLayout from 'components/layout/MainLayout';
import { AdyenCheckoutWrapper } from 'components/payments/AdyenCheckoutWrapper';
import { useEnterFlowPreconditionCheck } from 'hooks/enter/useEnterFlowPreconditionCheck';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { GetServerSideProps } from 'next';
import { useEffect } from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import ShoppingCart from '../components/svg/ShoppingCart.svg';
import styles from './checkout.module.css';

interface EnterNowCheckoutProps {}

const EnterNowCheckout = observer((props: EnterNowCheckoutProps) => {
  const enterStore = useEnterStore();

  useEffect(() => {
    (async () => enterStore.handleContinueToPayment())();
  }, []);
  useEnterFlowPreconditionCheck();

  return (
    <MainLayout limitItemWidths>
      <EnterLayout
        sidePanel={
          <div className={styles.sidePanel}>
            <h2 className={'aboutUsTypographyHeaderMedium ' + styles.heading}>
              <ShoppingCart />
              <span>Your order</span>
            </h2>
            <hr />
            <p>
              Your numbers look great!
              <br />
              Here they are once more
            </p>
            <div className={styles.entryContainer}>
              <TicketStack
                entries={enterStore.lines}
                withLoadingSkeleton={false}
                expanded
                hideExpandButton
              />
            </div>
            <hr />
            <div>
              {/* Placed in a separate DIV so that it can be centered without being full width */}
              <OrderSummaryRows showDays={true} />
            </div>
            <hr />
            <PromoCodeEntry />
            <OrderSummaryCosts />
            <hr />
            <strong className={styles.cancelText}>👋 Cancel anytime 👋</strong>
          </div>
        }
        sidePanelBackground={'GREY'}
        stepIcon={null}
        stepIntroText={null}
        stepName="Payment"
        stepIndex={5}
      >
        <div className={styles.mainPanel}>
          <AdyenCheckoutWrapper />
        </div>
        <div className={styles.logos}>
          <img
            src={`${ASSET_PREFIX}/images/enter/payment-icons/secure-checkout.svg`}
            alt=""
          />
          <img
            src={`${ASSET_PREFIX}/images/enter/payment-icons/privacy-protected.svg`}
            alt=""
          />
          <img
            src={`${ASSET_PREFIX}/images/enter/payment-icons/trustpilot.svg`}
            alt=""
          />
        </div>
      </EnterLayout>
    </MainLayout>
  );
});

export default EnterNowCheckout;

export const getServerSideProps: GetServerSideProps<
  EnterNowCheckoutProps
> = async (_ctx) => {
  return {
    props: {},
  };
};
